"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymousClient = void 0;
const BaseClient_1 = require("../BaseClient");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
class AnonymousClient extends BaseClient_1.BaseClient {
    constructor(app, entity, baseUrl) {
        super(baseUrl);
        this.app = app;
        this.entity = entity;
    }
    storageGet(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/api/v1/anonymous/storage/get',
                params: {
                    app: this.app,
                    entity: this.entity,
                    id: id,
                },
            });
            return response.data;
        });
    }
    storageList(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/api/v1/anonymous/storage/list',
                data: Object.assign(Object.assign({}, request), { app: this.app, entity: this.entity }),
            });
            return response.data;
        });
    }
    storageListParents(id, includeSelf) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/api/v1/anonymous/storage/listParents',
                params: {
                    app: this.app,
                    entity: this.entity,
                    id: id,
                    includeSelf: includeSelf,
                },
            });
            return response.data;
        });
    }
    /**
     * Convenience method to get count of rows by filter
     */
    storageCount(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.storageList({ filter: request.filter, limit: 0 });
            return response.total;
        });
    }
    storagePost(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/api/v1/anonymous/storage/post',
                data: Object.assign(Object.assign({}, request), { app: this.app, entity: this.entity }),
            });
            return response.data;
        });
    }
    executeFunction(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/api/v1/anonymous/function',
                params: {
                    app: this.app,
                },
                data: request,
            });
            return response.data;
        });
    }
}
exports.AnonymousClient = AnonymousClient;
